// parseLatLon, parse a free-typed "lat, lon" string into {lat, lon}, or null.
// Shared by the desktop location input (LeftConsole) and the mobile location
// entry (MobilePaneTonight) so both accept exactly the same format and bounds -
// no per-platform parsing drift.
export function parseLatLon(str) {
  const raw = String(str || '').replaceAll('−', '-').split(',').map(s => s.trim());
  if (raw.some(s => !/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(s))) return null;
  const parts = raw.map(Number);
  if (parts.length !== 2) return null;
  const [lat, lon] = parts;
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
  if (lat < -90 || lat > 90 || lon < -180 || lon > 180) return null;
  return { lat, lon };
}
